import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { useDeleteDraftMutation } from '../../api/useDeleteDraftMutation';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { isConsumerArea } from '../../../../CommonSelectors/CommonAreaSelector';
import { navigateToConsumerLandingPage } from '../../../../ConsumerArea/utils/navigateToConsumerLandingPage';

interface Props {
  clientId: string;
  draftId: string;
  onClose(): void;
  onSuccess?(): void;
}

export const CancelDialog: React.FC<Props> = ({ clientId, draftId, onClose, onSuccess }) => {
  const isConsumer = useSelector(isConsumerArea);

  const {
    mutateAsync: deleteDraft,
    isLoading: isDeletingDraft,
    error: deleteDraftError,
  } = useDeleteDraftMutation();

  const onDeleteDraft = async () => {
    try {
      await deleteDraft({ clientId, draftId });

      if (onSuccess) {
        onSuccess();
        return;
      }

      if (isConsumer) {
        navigateToConsumerLandingPage();
      } else {
        ADV.util.Router.go2('ConsumerOverview', { clientId });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose} size="medium" contentLabel="Cancel account opening">
      <ModalHeader variant="warning">Warning</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        {deleteDraftError && <Alert message={deleteDraftError.message} variant="error" mb="16" />}

        <Text>Are you sure you want to cancel your application?</Text>
      </ModalBody>

      <ModalFooter>
        <Button onClick={onClose} variant="subtleInactive" mr="12">
          No
        </Button>

        <Button variant="error" onClick={onDeleteDraft} isLoading={isDeletingDraft}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
